import { Button, Grid, Stack, styled } from '@mui/material';
import React, { useEffect, useState } from 'react';

import WsColors from '../../WsColors';
import { Label } from '../Label';

export interface WsButtonGroupProps {
  inputTitle: string;
  buttonsList?: Array<string>;
  variant?: 'outlined' | 'text' | 'contained' | 'white';
  showMandatorySymbol?: boolean;
  size?: 'small' | 'medium' | 'large';
  selectedIndexValue?: (index: number, value: string) => void;
  selectedMultipleIndexValue?: (index: number[], value: string[]) => void;
  defaultValue?: number;
  defaultMultipleValue?: number[];
  multiple?: boolean;
  triggerReset?: boolean;
  hideInputTitle?: boolean;
  disabled?: boolean;
}
interface ColorProps {
  selectedColor?: string;
}
const BtnStyle = styled(Button)(({ selectedColor }: ColorProps) => ({
  backgroundColor: selectedColor,
  fontSize: '14px',
  fontWeight: '600',
  borderRadius: '4px',
  color: WsColors.TheBlues500,
  borderColor: WsColors.TheBlues500,
  textTransform: 'none',
  '&:active': {
    backgroundColor: WsColors.TheBlues50,
  },
  '&:hover': {
    backgroundColor: WsColors.TheBlues50,
    borderColor: WsColors.TheBlues500,
  },
}));

const WsButtonGroup = ({
  inputTitle,
  buttonsList,
  selectedIndexValue,
  variant = 'outlined',
  showMandatorySymbol = false,
  size = 'medium',
  selectedMultipleIndexValue,
  defaultValue = -1,
  defaultMultipleValue = [],
  multiple = false,
  triggerReset = false,
  hideInputTitle = false,
  disabled = false,
}: WsButtonGroupProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(defaultValue);
  const [multipleSelectedIndex, setMultipleSelectedIndex] =
    useState<number[]>(defaultMultipleValue);
  const [multipleSelectedValue, setMultipleSelectedValue] = useState<string[]>([]);
  const onChange = (index: number, value: string) => {
    setSelectedIndex(index);
    selectedIndexValue && selectedIndexValue(index, value);
  };

  const onSelect = (index: number, value: string) => {
    let tempSelectedIndex = [...multipleSelectedIndex];
    let tempSelectedValue = [...multipleSelectedValue];
    if (tempSelectedIndex.includes(index)) {
      tempSelectedIndex = tempSelectedIndex.filter((ind) => ind !== index);
      tempSelectedValue = tempSelectedValue.filter((val) => val !== value);
    } else {
      tempSelectedIndex.push(index);
      tempSelectedValue.push(value);
    }
    setMultipleSelectedIndex(tempSelectedIndex);
    setMultipleSelectedValue(tempSelectedValue);
    selectedMultipleIndexValue && selectedMultipleIndexValue(tempSelectedIndex, tempSelectedValue);
  };

  useEffect(() => {
    if (triggerReset && selectedIndex != defaultValue) setSelectedIndex(defaultValue);
  }, [defaultValue, selectedIndex, triggerReset]);

  return (
    <>
      {!hideInputTitle && (
        <Stack direction="row" spacing={1}>
          <Label>
            {inputTitle}
            {showMandatorySymbol ? ' *' : ''}
          </Label>
        </Stack>
      )}
      <Grid item container columnGap={1} rowGap={1}>
        {buttonsList?.map((btn, index) =>
          !multiple ? (
            <BtnStyle
              id={`button_group_${index}`}
              variant={variant}
              size={size}
              key={index}
              onClick={() => onChange(index, btn)}
              selectedColor={index === selectedIndex ? WsColors.TheBlues100 : WsColors.White}
              disabled={disabled}
            >
              {btn}
            </BtnStyle>
          ) : (
            <BtnStyle
              id={`button_group_${index}`}
              variant={variant}
              size={size}
              key={index}
              onClick={() => onSelect(index, btn)}
              selectedColor={
                multipleSelectedIndex.includes(index) ? WsColors.TheBlues100 : WsColors.White
              }
              disabled={disabled}
            >
              {btn}
            </BtnStyle>
          )
        )}
      </Grid>
    </>
  );
};
export default WsButtonGroup;
